import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./supportTab.scss";
import { useTranslation } from "react-i18next";

interface ISupportTabProps {
  children: React.ReactNode;
  startOpen?: boolean;
}

interface ISupportTabState {
  tabRef: React.MutableRefObject<HTMLDivElement>;
  isTabOpen: boolean;
}

export function SupportTab(props: ISupportTabProps) {
  const { children = false } = props;
  const { t } = useTranslation();
  const [supportTabState, setSupportTabState] = useState<ISupportTabState>({
    tabRef: useRef<HTMLDivElement>(),
    isTabOpen: false,
  });

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideDropdownClick);
    document.addEventListener("touchstart", handleOutsideDropdownClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideDropdownClick);
      document.removeEventListener("touchstart", handleOutsideDropdownClick);
    };
  }, []);

  function handleOutsideDropdownClick(event: any) {
    if (!supportTabState.tabRef.current || supportTabState.tabRef.current.contains(event.target as Node)) {
      return;
    }

    setSupportTabState(prev => ({ ...prev, isTabOpen: false }));
  }

  function toggleSupportTabVisibility() {
    setSupportTabState(prev => ({ ...prev, isTabOpen: !prev.isTabOpen }));
  }

  return (
    <div ref={supportTabState.tabRef} className="support-tab">
      <OverlayTrigger
        placement="auto"
        overlay={
          supportTabState.isTabOpen ? (
            <div></div>
          ) : (
            <Tooltip id="leftMenuToolTip">{`${t("Support")}`}</Tooltip>
          )
        }
      >
        <div onClick={toggleSupportTabVisibility}>{children}</div>
      </OverlayTrigger>
      <div style={{ display: supportTabState.isTabOpen ? "block" : "none" }} className="support-tab-content">
        <div className="support-tab-content-header">{t("Support")}</div>
        <hr className="support-tab-content-dividing-line" />
        <div className="support-tab-content-options">
          <div className="contents" onClick={toggleSupportTabVisibility}>
            <a
              href="https://5nupvd.share-na3.hsforms.com/2AJQ3IYEATDqKsKxmztN99Q"
              target="_blank"
              className="support-tab-content-option"
              rel="noreferrer"
            >
              <FontAwesomeIcon className="support-tab-content-option-icon" icon={["far", "ticket"]} />
              <div>{t("Submit Ticket")}</div>
            </a>
            <a
              href="https://academy.teeon.com/academy-cloud"
              target="_blank"
              className="support-tab-content-option"
              rel="noreferrer"
            >
              <FontAwesomeIcon className="support-tab-content-option-icon" icon={["far", "question"]} />
              <div>{t("Help Center")}</div>
            </a>
            <a
              href="https://academy.teeon.com/academy-cloud/release-notes-updates"
              target="_blank"
              className="support-tab-content-option"
              rel="noreferrer"
            >
              <FontAwesomeIcon className="support-tab-content-option-icon" icon={["far", "code-merge"]} />
              <div>{t('Release Notes')}</div>
            </a>
            <a href="tel:5194347877" className="support-tab-content-option">
              <FontAwesomeIcon className="support-tab-content-option-icon" icon={["far", "phone"]} />
              <div>{t("Phone")}</div>
            </a>
            <a href="mailto:support@teeon.com" className="support-tab-content-option">
              <FontAwesomeIcon className="support-tab-content-option-icon" icon={["far", "envelope"]} />
              <div>{t("Email")}</div>
            </a>
            <a
              href="https://tee-on.beyondtrustcloud.com"
              target="_blank"
              className="support-tab-content-option"
              rel="noreferrer"
            >
              <FontAwesomeIcon className="support-tab-content-option-icon" icon={["far", "cloud-arrow-up"]} />
              <div>{t("Remote")}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
